import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  useGetAvailableSlotsQuery,
  useGetUnavailableDaysQuery,
} from '../../Api/availability';
import { useRescheduleMutation, useReserveSlotMutation } from '../../Api/reservations';
import useTranslate from '../../Hooks/useTranslate';
import Modal from '../../Style-guide/Modal';
import AvailableHours from './availableHoursSection';
import CalendarSection from './calendarSection';
import ReservationsWrapper from './style/reservationsWrapper';

const Reservations = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState({ start: null, end: null });

  const [showReserveModal, setShowReserveModal] = useState(false);
  const [showRescheduleModal, setShowRescheduleModal] = useState(false);
  const { courtId } = useParams();
  const [searchParams] = useSearchParams();
  const tr = useTranslate();

  const mode = searchParams.get('mode') || 'new';
  const reservationId = searchParams.get('reservationId') || null;
  const isRescheduling =
    mode === 'reschedule' && searchParams.get('reservationId') !== null;

  const now = new Date();
  const currentDateString = now.toISOString().split('T')[0];
  const queryDate = selectedDate
    ? selectedDate.toISOString().split('T')[0]
    : currentDateString;

  const { data: availablePeriods } = useGetAvailableSlotsQuery({
    params: { courtId },
    queryParams: { date: queryDate },
  });

  const { data: unavailableDaysInCalendar } = useGetUnavailableDaysQuery({
    params: { courtId },
  });

  const { mutate: reservationRequest } = useReserveSlotMutation();
  const { mutate: rescheduleRequest } = useRescheduleMutation();

  const { availability, workingDays, maxDaysAheadToReserve } = availablePeriods || {};

  const reserveModalText = tr('reserve_court_modal_text')
    ?.replace('{time}', `${selectedSlot.start} - ${selectedSlot.end}`)
    ?.replace('{date}', queryDate);

  const rescheduleModalText = tr('reschedule_court_modal_text')
    ?.replace('{time}', `${selectedSlot.start} - ${selectedSlot.end}`)
    ?.replace('{date}', queryDate);

  return (
    <ReservationsWrapper>
      <CalendarSection
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        workingDays={workingDays}
        maxDaysAheadToReserve={maxDaysAheadToReserve}
        unavailableDays={unavailableDaysInCalendar}
      />
      <AvailableHours
        selectedSlot={selectedSlot}
        setSelectedSlot={setSelectedSlot}
        availability={availability}
        setShowModal={isRescheduling ? setShowRescheduleModal : setShowReserveModal}
      />

      <Modal
        show={showReserveModal}
        onClose={() => setShowReserveModal(false)}
        confirmation
        question={reserveModalText}
        confirmText={tr('yes_reserve_please')}
        cancelText={tr('no_thanks')}
        onConfirm={() =>
          reservationRequest({
            data: { date: queryDate, timeSlot: selectedSlot },
            params: { courtId },
          })
        }
      />

      <Modal
        show={showRescheduleModal}
        onClose={() => setShowRescheduleModal(false)}
        confirmation
        question={rescheduleModalText}
        confirmText={tr('yes_reschedule_please')}
        cancelText={tr('no_thanks')}
        onConfirm={() =>
          rescheduleRequest({
            data: { date: queryDate, timeSlot: selectedSlot },
            params: { reservationId },
          })
        }
      />
    </ReservationsWrapper>
  );
};

export default Reservations;
